import IntegrationCard from './IntegrationCard';
import React, { useEffect } from 'react';
import { useIntegrationsStore } from '../../../stores/use-integrations-store';

import ConfirmAlert from '../../../components/ConfirmAlert';
import AlertAccent from '../../../components/AlertErrorBox';
import { useDeleteIntegration } from '../hooks/useDeleteIntegration';
import Modal from '../../../components/Modal';
import AddIntegrationForm from './AddIntegrationForm';
import { useGisZhkkhPaymentPolling } from '../gisZhkkh';

const IntegrationList = () => {
  const { integrations, fetchIntegrations, fetchTypeIntegrations, fetchTemplatesIntegrations } = useIntegrationsStore();
  const { confirmOpen, setConfirmOpen, pendingDelete, handleDeleteClick, handleConfirm } = useDeleteIntegration();
  const [showModal, setShowModal] = React.useState(false);
  const [selectDevice, setSelectDevice] = React.useState();

  useGisZhkkhPaymentPolling();

  useEffect(() => {
    const fetch = async () => {
      await Promise.all([fetchTypeIntegrations(), fetchIntegrations(), fetchTemplatesIntegrations()]);
    };
    fetch();
  }, []);

  const handleAddIntegration = (device) => {
    setShowModal(true);
    setSelectDevice(device);
  };

  return (
    <>
      {integrations?.length > 0 &&
        integrations.map((integration) => {
          const { address, apartment, id } = integration?.object_info ?? {};
          const devices = integration?.devices_integrations_info;

          return (
            <div key={id} className={'pb-4'}>
              <p className={'text-lg mb-2'}>
                {address}, кв {apartment}
              </p>

              <div className={'grid grid-cols-1 gap-2 lg:grid-cols-2 2xl:grid-cols-3 w-full'}>
                {devices?.length > 0 &&
                  devices?.map((device) => {
                    const { device_type, integrations, device_serial_number, device_id, device_subtype_key } = device ?? {};

                    return (
                      <IntegrationCard
                        key={device_id}
                        objectId={id}
                        deleteHandle={handleDeleteClick}
                        title={device_type}
                        description={device_serial_number}
                        integrations={integrations}
                        deviceId={device_id}
                        subtype={device_subtype_key}
                        setSelectDevice={() => handleAddIntegration(device)}
                      />
                    );
                  })}
              </div>
            </div>
          );
        })}
      <ConfirmAlert showAlert={confirmOpen} setShowAlert={setConfirmOpen} delCb={handleConfirm} title="Удаление интеграции">
        <AlertAccent
          text={`Вы действительно хотите удалить интеграцию ${pendingDelete?.integration_name ? `«${pendingDelete.integration_name}»` : ''}?`}
          showAlert={true}
        />
      </ConfirmAlert>

      <Modal showModal={showModal} setShowModal={setShowModal} title={'Добавить интеграцию'}>
        <AddIntegrationForm onClose={() => setShowModal(false)} device={selectDevice} />
      </Modal>
    </>
  );
};

export default IntegrationList;
